import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  validationMessage: {
    marginTop: 16,
    marginBottom: 16
  },
  resolutionList: {
    margin: '8px 0',
    paddingLeft: 20,
    '& li': {
      marginBottom: 4
    }
  },
  resolutionSection: {
    marginTop: 12
  },
  resolutionTitle: {
    fontWeight: 'bold',
    marginBottom: 8
  }
})

export default useStyles
